// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"197":"75fc9c18","293":"component---src-pages-index-js","518":"8a28b14e"}[chunkId] || chunkId) + "." + {"197":"ca46cf95423a69281dad","293":"c3fe5daf7aa627b92680","518":"609fcb9d59066425338c","779":"9ad24f5e9143dbf586eb"}[chunkId] + ".js";
};